import { getActiveDecisionVariable, getSplitTestConfigsAsync } from 'Shared/services/opa/app/splitTestService';
import { OPA_FLAG, OPA_VARIABLE } from 'Shared/services/opa/constants';

/**
 * Resolves whether the RepData (Research Defender) token fetch is enabled via the
 * Optimizely flag `sjsurvey-2375` (boolean variable `enabled`).
 *
 * Uses the async decision read so the gate is correct even when the split-test
 * cache is cold — this is evaluated at login/refresh time and the token is only
 * fetched once per sid, so a stale "disabled" read from an empty cache would
 * otherwise skip the fetch for the whole session. Defaults to disabled on error.
 */
export const isRepDataTokenFetchEnabled = async (): Promise<boolean> => {
  try {
    const decisions = await getSplitTestConfigsAsync([OPA_FLAG.REPDATA_TOKEN_SJSURVEY_2375]);

    return getActiveDecisionVariable<boolean>(
      OPA_FLAG.REPDATA_TOKEN_SJSURVEY_2375,
      decisions,
      OPA_VARIABLE.REPDATA_TOKEN_ENABLED
    ) === true;
  } catch {
    return false;
  }
};
